import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppManager from "../../managers/AppManager";
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import EmployeeListService from "../../services/EmployeeListService";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import ReadWatchComponent from "../common/ReadWatchComponent";
import {
  fetchTenantData,
  selectTenanatData,
} from "../../Redux/Slices/EmployeeListSlice";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import {
  showAlert,
  showToast,
  TOAST_TYPE,
  DKIcons,
  DKLabel,
  DKButton
} from "deskera-ui-library";
import { contractorColumnConfig, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import Table from "../../services/table";
import { fetchContractor, selectContractor } from "../../Redux/Slices/ContractorSlice";
import { exportContractors, getFile, triggerDownload } from "../import_export/utility/ExportData";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { COUNTRY } from "../../constants/CountryConstant";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const Contractor = (props) => {

    const initialState = {
      columnData: [],
      rowData: [],
      originalData: [],
      filter: [],
    };

     const cannotDeleteOrUpdate = [
       {
         title: "Cancel",
         className: "bg-gray1 border-m",
       },
     ];

     const deleteConfirm = (data) => [
       {
         title: "Cancel",
         className: "bg-gray1 border-m",
       },
       {
         title: "Delete",
         className: "bg-red text-white ml-r",
         onClick: () => deleteRecord(data),
       },
     ];

    //Hooks
    const [contractor, setContractor] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    //Store
    const dispatch = useDispatch();
    const contractorData = useSelector(selectContractor);
    const tenantData = useSelector(selectTenanatData);
    const [reload, setReload] = useState(false);

    var selectedRow = [];
    const [exportButtonName, setExportButtonName] = useState("Export Contractor")

    useEffect(() => {
        RouteManager.setPresenter({ props });
        loadContractor({
          Limit: 20,
          currentPage: "1",
          sort: "clockIn",
          order: "desc",
          field: `_id`,
          searchField: ``,
          searchString: ``,
          userType: `contractor`,
        });
        loadTenantData({});
        /* API Calls End */
        return () => setContractor(initialState);
    }, []);

    useEffect(() => {
      if (!Utility.isEmpty(contractorData)) {
        const { users, filterConfig } = contractorData;
        const { tenant } = tenantData;
        const rowData = contractorColumnConfig(users);
        let contractorColumns = parseColumnConfig(
          TableManger.getTableColumns(TABLES.CONTRACTOR_LIST),
          TABLES.CONTRACTOR_LIST
        );
        let columns = parseVisibleColumnConfig(contractorColumns);
        // changeColumnName(employeeColumn, "", TABLES.PEOPLE_COMPONENT, {
        //   isFromEmployeeSetup: isFromEmployeeSetup,
        // });
        const passingData = {
          columnData: deepClone(columns),
          rowData,
          filter: [],
          originalData: rowData,
        };

        setContractor(passingData);
        setTotalPageCount(parseInt(filterConfig.totalPage));
        setCurrentPage(parseInt(filterConfig.page));
        setTotalCount(parseInt(filterConfig.numberOfRecords));
        // setEmployeeCountForBeneficiary(parseInt(beneficiariesToAdd));
      }
    }, [contractorData, tenantData, reload]);

    const loadContractor = async (config) => {
      try {
        EmployeeListService.apiConfig = config;
        const timeout = showDelayedLoader();
        await dispatch(fetchContractor());
        removeDelayedLoader(timeout);
      } catch (err) {
        console.error("Error loading contacts: ", err);
      }
    };

    const loadTenantData = async (config) => {
      try {
        await dispatch(fetchTenantData());
      } catch (err) {
        console.error("Error loading tenant data: ", err);
      }
    };

    const onRowEdit = (data) => {
      let rowData = data && data.rowData ? data.rowData : (data && data.length >0 ? data[0]: "");
      if(rowData && rowData.userId) {
        RouteManager.navigateToPage(
          PAGE_ROUTES.CONTRACTOR_DETAILS,
          `&id=${rowData.userId}&isEdit=true`
        );
      }

    }

    const onCreateNew= () => {
        RouteManager.navigateToPage(
          PAGE_ROUTES.CONTRACTOR_DETAILS,
          `&isEdit=false`
        );
    }

    const onDeleteContact = (data) => {
      let isMultiDelete = data && data.length > 0 ? true : false;

      const row = data && data.rowData ? data.rowData : {};
      if (row && row.userId && !isMultiDelete) {
        let owner = row.roles.filter(
          (role) =>
            role.appName === "PEOPLE" &&
            (role.name === "ADMIN" || role.name === "OWNER")
        );
        if (owner && owner.length > 0) {
          showAlert(
            "Sorry!!",
            "Employee with Admin role cannot be deleted",
            cannotDeleteOrUpdate
          );
        } else {
          showAlert(
            "Delete Record?",
            "Are you sure you want to delete this record? This action cannot be undone later.",
            deleteConfirm([row])
          );
        }
      } else if (isMultiDelete) {
        let isAdmin = false;
        data.forEach((rows) => {
          if (rows && rows.userId) {
            let owner = rows.roles.filter(
              (role) =>
                role.appName === "PEOPLE" &&
                (role.name === "ADMIN" || role.name === "OWNER")
            );
            if (owner && owner.length > 0) {
              isAdmin = true;
            }
          }
        });
        if (!isAdmin) {
          showAlert(
            "Delete Record?",
            "Are you sure you want to delete this record? This action cannot be undone later.",
            deleteConfirm(data)
          );
        }
      }
    };

    const deleteRecord = (data) => {
      const userId = [];
      data.forEach((row) => {
        userId.push(row.userId);
      });
      const parameter = { ids: userId };
      Table.deleteEmployee(parameter).then((data) => {
        showToast("Record Deleted Successfully", TOAST_TYPE.SUCCESS);
        loadContractor({
          ...EmployeeListService.apiConfig,
          userType: "contractor"
        });
      });
    };

    const onSearch = (searchTerm) => {
      const config = {
        ...EmployeeListService.apiConfig,
        Page: 0,
        SearchTerm: searchTerm,
        userType:"Contractor"
      };
      loadContractor(config);
    };
    const newColumnAdded = (data) => {
      const columns = contractor.columnData;
      columns.push(data);
      setContractor({ ...contractor, columnData: columns });
    };
    const getFieldNameForSort = (columnCode) => {
      let fieldName = columnCode;
      switch(columnCode) {
        case COLUMN_CODE.PEOPLE_CONTRACTOR_LIST.EMPLOYEE_NAME:
          fieldName = 'meta.firstName';
          break;
        default:
          fieldName = columnCode;
          break;
      }
      return  fieldName
    }
    const onFilter = (updatedList, queries) => {
      let value;
      let columnSeleacted;
      if (queries.length != 0) {
        queries.forEach((query) => {
          columnSeleacted = TableManger.getColumnById(
            TABLES.CONTRACTOR_LIST,
            query.key
          );
          console.log(columnSeleacted);
          if (Array.isArray(query.value)) {
            value = query.value[0] ? query.value[0] : "";
          } else {
            value = query.value;
          }
        });
        if (columnSeleacted && columnSeleacted.columnCode) {
          let searchObj = {
            searchField: columnSeleacted.columnCode,
            id: value,
          };
          if (columnSeleacted.columnCode == "status") {
            // setSelectedFilterData(searchObj);
          } else {
            const config = {
              ...EmployeeListService.apiConfig,

              customJson: {
                "orderBy.field": "firstName",
                "orderBy.order": "asc",
                searchString: value,
              },
            };
            loadContractor(config);
          }
        }
      } else {
        const config = {
          ...EmployeeListService.apiConfig,
          searchString: "",
          searchField: "",
          userType:"Contractor"
        };
        loadContractor(config);
      }
    };

    // const setSelectedFilterData = (data) => {
    //   if (selectedEmployeeFilter.id != data.id) {
    //     setSelectedEmployeeFilter(data);
    //     loadEmployee({
    //       ...EmployeeListService.apiConfig,
    //       searchString: data.id,
    //       searchField: data.searchField,
    //     });
    //   }
    // };

    const onRowAdd = (newRow) => {
      // if (newRow) {
      //     let updatedRowData = [...contacts.rowData];
      //     updatedRowData.unshift(newRow);
      //     setContacts({
      //         ...contacts,
      //         rowData: updatedRowData,
      //         originalData: updatedRowData
      //     });
      // }
    };
    const onView = (data) => {
      let rowData = data && data.rowData ? data.rowData : (data && data.length >0 ? data[0]: "");
        if(rowData && rowData.userId) {
          RouteManager.navigateToPage(
            PAGE_ROUTES.CONTRACTOR_VIEW,
            `id=${rowData.userId}`
          );
        }
    }
    const onSort = (data) => {
      const config = {
        ...EmployeeListService.apiConfig,
        order: data.order.toLowerCase(),
        field: getFieldNameForSort(data.columnData.columnCode),    
        userType:"Contractor"
      };
      loadContractor(config);
    }

    const onContextCancel = () => {
      setReload(!reload)
    }

    const exportContractos = () => {
        if (contractor.rowData?.length === 0) {
            showToast('No records to export.', TOAST_TYPE.FAILURE);
            return
        }

        const selectedContractors = selectedRow.filter(item => item).map(item => item.userId);
        const data = {
            userIds: selectedContractors
        }

        setExportButtonName('Exporting...')
        exportContractors(data).then((res) => res.blob())
            .then((blob) => {
                if (blob?.size > 0) {
                    const file = getFile(blob, "Contractor", "xlsx");
                    triggerDownload(file, file.name);
                    setExportButtonName('Export Contractor')
                    showToast('Contractor exported Successfully', TOAST_TYPE.SUCCESS);
                    setReload(!reload);
                } else {
                    setExportButtonName('Export Contractor')
                    showToast('Internal server error.', TOAST_TYPE.error);
                    setReload(!reload);
                }
            }
        ).catch(
            (err) => {
                setExportButtonName('Export Contractor');
                showToast('Internal server error.', TOAST_TYPE.error);
                setReload(!reload);
            }
        );
    }

    const isExportEnabled = () => {
      return PermissionUtils.hasAccess(MODULE.CONTRACTOR, ACTION.EXPORT) && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.VIEW);
    }

    return (
      <>
        <div className="mb-l parent-width banner-holder row">
          <ReadWatchComponent
            title="Need help getting started? Learn more about creating Contractors."
            onRead={() =>
              window.open(
                "https://www.deskera.com/care/view-edit-delete-terminate-employee-deskera-hris/",
                "_blank"
              )
            }
            onWatch={AppManager.showComingSoonWarning}
          />
            {!isMobileWebView() && isExportEnabled() && <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width ml-l banner-holder">
                <DKLabel text='<span style="font-size:20px">💼</span> Manage your Contractors.' />
                <div className="row mt-r">
                    <DKButton
                        title={exportButtonName}
                        icon={DKIcons.ic_export}
                        className="border-m bg-white ml-l"
                        onClick={() => {
                            exportContractos();
                        }}
                    />
                </div>
            </div>}
        </div>
        <div className="column parent-width flex-1">
          <div className="column mt-l parent-width mb-s position-relative flex-1 margin-empty-mobile">
            <DataGridHolderPayroll
              tableName={TABLES.CONTRACTOR_LIST}
              displayTableName={
                 TABLE_DISPLAY_NAME[TABLES.CONTRACTOR_LIST]
              }
              allowColumnEdit={false}
              allowColumnDelete={false}
              allowColumnShift={false}
              allowSearch={false}
              allowFilter={false}
              allowColumnAdd={false}
              onRowDelete={onDeleteContact}
              onRowEdit={(data) => {
                onRowEdit(data);
              }}
              onCancelContext={() => {
                onContextCancel();
              }}
              allowRowAdd={true}
              addButtonConfig={[
                {
                  title: "+ Add Contractor",
                  className: "bg-app text-white",
                  onClick: () => onCreateNew(),
                },
              ]}
              allowDataExport={false}
              gridData={contractor}
              onSearch={onSearch}
              onColumnAdd={newColumnAdded}
            //   onFilter={onFilter}
              filter={contractor.filter}
              onRowAdd={onRowAdd}
              onPaginationClick={(requestedPageNumber) => {
                const config = {
                  ...EmployeeListService.apiConfig,
                  currentPage: requestedPageNumber,
                };
                loadContractor({...config, userType:"Contractor"});
              }}
              currentPage={currentPage}
              totalPageCount={totalPageCount}
              isActionEnabled={true}
              contextMenu={true}
              isMenuVisible={true}
              allowRowEdit={PermissionUtils.hasAccess(MODULE.CONTRACTOR, [ACTION.EDIT])}
              showContextEdit={false}
              onView={onView}
              onSort={onSort}
              onSelection={(data)=>{
                selectedRow = data
              }}
              onColumnShift={(data)=> setReload(!reload)}
              module={MODULE.CONTRACTOR}
            />
          </div>
        </div>
      </>
    );
}

export default Contractor;
